import { isEmbeddedNativeWebView } from "@albertine/wrapper-interop";
import { isEmbeddedInParentFrame } from "../parentFrame";

// The member login goes through dev-only clients of the local Keycloak, so it
// only works on the local dev server. Keeping this a constant lets every
// other build drop the dev login code entirely.
export const DEV_MEMBER_LOGIN_ENABLED =
    import.meta.env.DEV && import.meta.env.ALBERTINE_ENV === "localhost";

// Embedding hosts provide the member's token themselves, so the dev login only
// stands in for a host when the mini-app runs on its own.
export function usesDevMemberLogin(): boolean {
    return (
        DEV_MEMBER_LOGIN_ENABLED &&
        !isEmbeddedInParentFrame() &&
        !isEmbeddedNativeWebView()
    );
}
